export default {"src":"/_next/static/media/Chevron_down.29b40726.svg","height":34,"width":34};